import React from 'react'

import { Box, Link, Typography } from '@mui/material'

function Faq() {
  const REACT_APP_PDF_MANUAL = "/movopsi_manual.pdf";
  const REACT_APP_PDF_FILE_FORMAT_DATA = "/psi_fileformat_data.pdf";
  const REACT_APP_PDF_FILE_FORMAT_MASTER = "/psi_fileformat_master.pdf";
  return (
    <Box>
      <Typography component="div" variant="largeBold">
        操作マニュアル (別タブで開きます)
      </Typography>
      <Typography sx={{ paddingTop: 5, paddingLeft: 6}}
        component="body" variant='largeBold'>
        <Link
          href={REACT_APP_PDF_MANUAL}
          target="_blank" 
          rel="noopener noreferrer" 
          sx={{ color: '#1a73e8', 
            textDecoration: 'underline', 
            textDecorationColor: '#1a73e8',
            fontWeight: 'bold' }}
        >
          操作マニュアルの表示
        </Link>
      </Typography>
      <Typography sx={{ paddingTop: 5, paddingLeft: 6}}
        component="body" variant='largeBold'>
        <Link
          href={REACT_APP_PDF_FILE_FORMAT_DATA}
          target="_blank" 
          rel="noopener noreferrer" 
          sx={{ color: '#1a73e8', 
            textDecoration: 'underline', 
            textDecorationColor: '#1a73e8',
            fontWeight: 'bold' }}
        >
          実績データファイルフォーマット説明書
        </Link>
      </Typography>
      <Typography sx={{ paddingTop: 5, paddingLeft: 6}}
        component="body" variant='largeBold'>
        <Link
          href={REACT_APP_PDF_FILE_FORMAT_MASTER}
          target="_blank" 
          rel="noopener noreferrer" 
          sx={{ color: '#1a73e8', 
            textDecoration: 'underline', 
            textDecorationColor: '#1a73e8',
            fontWeight: 'bold' }}
        >
          マスタデータ・入出荷明細アップロードフォーマット説明書
        </Link>
      </Typography>
    </Box>
  )
}

export default Faq
